import React from 'react';
import {
  leakDetection,
  cartridge,
  thermometerCold,
  thermometerHot,
  towerTransmit,
} from 'images';
import styles from './styles.scss';

const SecondAnswer = () => (
  <div className={styles.secondAnswer}>
    <div className={styles.smallCol}>
      <div className={styles.items}>
        <img src={leakDetection} alt="Leak Detection" />
        <span>
          Leak
          <br />
          Detection
        </span>
      </div>
      <div className={styles.items}>
        <img src={cartridge} alt="Cartridge" />
        <span>FilterEfficiency</span>
      </div>
    </div>
    <div className={styles.bigCol}>
      <img src={towerTransmit} alt="Transmit" />
    </div>
    <div className={styles.smallCol}>
      <div className={styles.items}>
        <img src={thermometerCold} alt="Thermometer" />
        <span>
          Cooling
          <br />
          Performance
        </span>
      </div>
      <div className={styles.items}>
        <img src={thermometerHot} alt="Thermometer" />
        <span>
          Heating
          <br />
          Performance
        </span>
      </div>
    </div>
  </div>
);

export default SecondAnswer;
